import MoneyCell from './MoneyCell';

export default MoneyCell;
